export enum WorkspaceRoles {
  Suspended = 0,
  Viewer = 1,
  User = 3,
  Admin = 5,
  Owner = 7,
}

export enum WorkspaceVisibility {
  Public = 'public',
  Private = 'private',
}
